import { createContext, useEffect, useState } from 'react';
import InfoModal from 'ui-component/modals/InfoModal';
import ConfirmationModal from 'ui-component/modals/ConfirmationModal';
import PropTypes from 'prop-types';
import { NO_SUBSCRIPTION_MODAL_EVENT } from 'utils/entitlements';

export const ModalContext = createContext();

const ModalContextProvider = ({ children }) => {
    const [infoModal, setOpenInfoModal] = useState({ isOpen: false });
    const [confirmationModal, setOpenConfirmationModal] = useState({ isOpen: false });

    useEffect(() => {
        const handleNoSubscription = (event) => {
            setOpenInfoModal(event.detail);
        };

        window.addEventListener(NO_SUBSCRIPTION_MODAL_EVENT, handleNoSubscription);
        return () => window.removeEventListener(NO_SUBSCRIPTION_MODAL_EVENT, handleNoSubscription);
    }, []);

    const handleInfoModalClose = () => {
        const closeCallback = infoModal?.onClose;

        setOpenInfoModal((current) => ({
            ...current,
            isOpen: false,
            onClose: undefined
        }));

        closeCallback?.();
    };

    return (
        <ModalContext.Provider value={{ setOpenInfoModal, setOpenConfirmationModal }}>
            <InfoModal data={infoModal} onClose={handleInfoModalClose} />
            <ConfirmationModal
                data={confirmationModal}
                onClose={() => setOpenConfirmationModal((current) => ({ ...current, isOpen: false }))}
            />
            {children}
        </ModalContext.Provider>
    );
};

ModalContextProvider.propTypes = {
    children: PropTypes.node
};

export default ModalContextProvider;
